import ContactToken from '@apps/crm/admin/tokens/contact'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Send extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    email_campaign: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { email_campaign } = this.props
    return {
      title: 't(Send Email Campaign)',
      method: 'POST',
      action: `/api/admin/campaigns/email/${email_campaign.id}/send`,
      saveText: 't(Send)',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Contact)',
              name: 'contact_id',
              type: 'lookup',
              endpoint: '/api/admin/crm/recipients',
              defaultQuery: {
                purpose: 'transactional',
                channel: 'email',
                program_id: email_campaign.program.id
              },
              valueKey: 'contact.id',
              textKey: 'contact.display_name',
              format: (recipient) => (
                <ContactToken { ...recipient.contact } />
              )
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(result) {
    this.context.modal.close()
  }

}

export default Send
